import { NodeSubType } from "../../models/nodeSubType";
import { FallbackState } from "../fallback-response";

export enum ASSISTANT_QRB {
  TALK_TO_AGENT = "talkToAgent",
  MAIN_MENU = "mainMenu",
}

export const ASSISTANT_QRB_CARDS = [
  {
    id: ASSISTANT_QRB.TALK_TO_AGENT,
    label: "Talk to agent",
  },
  {
    id: ASSISTANT_QRB.MAIN_MENU,
    label: "Main menu",
  },
];

export type AiAssistantI = {
  id: string;
  name: string;
  type: AiAssistantType;
  is_draft: boolean;
};

export enum AiAssistantType {
  FAQ = "FAQ",
  PRODUCT_SEARCH = "Product Search",
  GENERAL_PURPOSE = "General Purpose",
}

export type AutoCloseConfig = {
  auto_close_enabled: boolean;
  auto_close_duration: number | null; // in minutes
};

export type AiAssistantBackendConfig = {
  type: string;
  sub_type: NodeSubType;
  node_index: number;
  custom_prompt?: string;
  assistant_config?: BikAiAssistantConfig;
  fallback?: FallbackState;
  conditions: {
    operator: "goto";
    operator_values: { [key: string]: { key: string; value: string } };
  }[];
  error_flow_config?: ErrorFlowConfig | null; // fallback flow
  auto_close_config?: AutoCloseConfig;
};

export type ErrorFlowConfig = {
  error_node_id: string;
}

export type AiAssistantFrontendConfig = {
  type: string;
  subType: NodeSubType;
  isMicroFlow: boolean;
  description: string;
  slang: string;
  childNodes: { [key: string]: { key: string; value: string } };
};

export type BikAiAssistantFunctions = {
  name: string; // GPTFunctionType
  params?: Record<string, any>;
};

export enum BikAiAssistantPromptType {
  GENERAL_PURPOSE_ASSISTANT = "general_purpose_assistant",
  ORDER_TRACKING = "order_tracking",
}

export type BikAiAssistantConfig = {
  data_sources: any[]; // Replace any with actual BikAiAssistantDataSource type if available
  functions: BikAiAssistantFunctions[];
  prompt_type: BikAiAssistantPromptType;
  output_message_format?: string;
};
